<template>
  <main class="px-6 text-center text-gray-700 dark:text-gray-200 bg-gray-50">
    <RouterView />
  </main>
</template>
